import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AppProvider } from './contexts/AppContext';
import { AdminProvider, useAdmin } from './contexts/AdminContext';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

/* Scroll to top on every route change */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetailPage from './pages/ProductDetailPage';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Wishlist from './pages/Wishlist';
import About from './pages/About';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import ShippingReturns from './pages/ShippingReturns';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProducts from './pages/admin/AdminProducts';
import ProductForm from './pages/admin/ProductForm';
import AdminOrders from './pages/admin/AdminOrders';
import './App.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAdmin();
  
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }
  
  return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

function App() {
  return (
    <AppProvider>
      <AdminProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <div className="App flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow"><Home /></main>
                <Footer />
              </div>
            } />
            <Route path="/shop" element={
              <div className="App flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow"><Shop /></main>
                <Footer />
              </div>
            } />
            <Route path="/product/:id" element={
              <div className="App flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow"><ProductDetailPage /></main>
                <Footer />
              </div>
            } />
            <Route path="/cart" element={
              <div className="App flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow"><Cart /></main>
                <Footer />
              </div>
            } />
            <Route path="/checkout" element={
              <div className="App flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow"><Checkout /></main>
                <Footer />
              </div>
            } />
            <Route path="/wishlist" element={
              <div className="App flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow"><Wishlist /></main>
                <Footer />
              </div>
            } />
            <Route path="/about" element={
              <div className="App flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow"><About /></main>
                <Footer />
              </div>
            } />
            <Route path="/contact" element={
              <div className="App flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow"><Contact /></main>
                <Footer />
              </div>
            } />
            <Route path="/blog" element={
              <div className="App flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow"><Blog /></main>
                <Footer />
              </div>
            } />
            <Route path="/blog/:id" element={
              <div className="App flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow"><BlogDetail /></main>
                <Footer />
              </div>
            } />
            <Route path="/shipping-returns" element={
              <div className="App flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow"><ShippingReturns /></main>
                <Footer />
              </div>
            } />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={
              <ProtectedRoute><AdminDashboard /></ProtectedRoute>
            } />
            <Route path="/admin/products" element={
              <ProtectedRoute><AdminProducts /></ProtectedRoute>
            } />
            <Route path="/admin/products/add" element={
              <ProtectedRoute><ProductForm /></ProtectedRoute>
            } />
            <Route path="/admin/products/edit/:id" element={
              <ProtectedRoute><ProductForm /></ProtectedRoute>
            } />
            <Route path="/admin/orders" element={
              <ProtectedRoute><AdminOrders /></ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
      </AdminProvider>
    </AppProvider>
  );
}

export default App;
